<template>
  <div class="manage">
    <h1>RentalAware Property Management</h1>
    <p>This tool provides insight into your property management business.</p>
  </div>
</template>

<script>
  export default {
    name: 'Manage',
    data() {
      return {
               
      }
    }
  }
</script>

<style scoped>
</style>